import { FacadeType } from "@biz/definitions/FacadeDefinitions";

function pad(n: string, width: number, z?: string): string {
  z = z || "0";
  n = n + "";
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

declare const __ENV: { app: FacadeType, buildTime: number; isServer: boolean; debug: boolean; mode: "development" | "production", useServiceWorker: boolean; webServiceUrl: string; withSentry?: boolean, beta?: boolean };

let env2: any;
export function getEnv2(): any {
  if (!env2)
    env2 = _getEnv2();
  return env2;
}
export function _getEnv2(): any {
  try {
    const env = process?.env;
    return env?.__ENV as any; // still used? server, dash?
  } catch {
    // Do nothing
  }
  try {
    return __ENV; // DASH, app_new, quick
  } catch {
    // Do nothing
  }
  return undefined;

}

export function isDebug(): boolean {
  const __env2 = getEnv2();
  if (__env2) return __env2.mode === "development" || __env2.debug;
  return __ENV?.debug;
}

export function isServer(): boolean {
  // console.log("isServer");
  const __env2 = getEnv2();
  if (__env2) return __env2.isServer;
  return __ENV?.isServer;
}

export function isBeta(): boolean {
  // console.log("isServer");
  const __env2 = getEnv2();
  if (__env2) return __env2.beta;
  return !!__ENV?.beta;
}

export function isWithSentry(): boolean {
  // console.log("isServer");
  const __env2 = getEnv2();
  if (__env2) return __env2.withSentry;
  return !!__ENV?.withSentry;
}

export function getWebserviceUrl(): string {
  const __env2 = getEnv2();
  if (__env2) return __env2.webServiceUrl || "";
  return __ENV?.webServiceUrl || "";
}

export function getAppType(): FacadeType {
  // console.log("getBuildTime");
  if (getEnv2()) return getEnv2().app;
  return __ENV?.app;
}

export function getBuildTime(): number {
  // console.log("getBuildTime");
  if (getEnv2()) return getEnv2().buildTime;
  return __ENV?.buildTime;
}

export function getVersionFromBuildTime(buildTime: number): string {
  return new Date(buildTime).toLocaleString("de");
}

export function getVersionShortFromBuildTime(buildtime: number): string {
  const d = new Date(buildtime);
  // return [d.getUTCHours(), d.getUTCMinutes(), d.getUTCDate(), d.getUTCMonth() + 1, d.getUTCFullYear() - 2000].map((v) => StringUtil.pad("" + v, 2)).join("");
  return [d.getUTCFullYear() - 2000, d.getUTCMonth() + 1, d.getUTCDate(), ".", d.getUTCHours(), d.getUTCMinutes()].map((v) => v === "." ? v : pad("" + v, 2)).join("");
}

export function getVersion(): string {
  const version = getEnv2()?.version;
  if (version)
    return version;
  return getVersionFromBuildTime(getBuildTime());
}

export function getGoogleKey(): string {
  // return isDebug() ? "AIzaSyATEuQn-lLxp36QW_gX1Z2i7DNaxh-NekU" : `AIzaSyDprPoKhMFat5ZV6fGcyw892c3a_z-Q2PE`;
  return "AIzaSyDprPoKhMFat5ZV6fGcyw892c3a_z-Q2PE";
}

export class BuildEnvironment {
  static get BuildTime(): string {
    return new Date(getBuildTime()).toLocaleString("de-DE", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
    });
  }

  static get BuildTimeAsNumber(): number {
    const bv = BuildEnvironment.getBuildVersion();
    return +bv.high * 10000 + +bv.low;
  }

  static get BuildTimeShort(): string {
    const d = new Date(getBuildTime());
    // return [d.getUTCHours(), d.getUTCMinutes(), d.getUTCDate(), d.getUTCMonth() + 1, d.getUTCFullYear() - 2000].map((v) => StringUtil.pad("" + v, 2)).join("");
    return [d.getUTCFullYear() - 2000, d.getUTCMonth() + 1, d.getUTCDate(), ".", d.getUTCHours(), d.getUTCMinutes()].map((v) => v === "." ? v : pad("" + v, 2)).join("");
  }

  static getBuildVersion(buildTime?: number): { high: string; low: string; } {
    const d = new Date(buildTime !== undefined ? buildTime : getBuildTime());
    return {
      high: [d.getUTCFullYear() - 2000, d.getUTCMonth() + 1, d.getUTCDate()].map((v) => pad("" + v, 2)).join(""),
      low: [d.getUTCHours(), d.getUTCMinutes()].map((v) => pad("" + v, 2)).join("")
    }
  }

  static get Version(): string {
    return getVersion();
  }
}

console.log("BuildEnvironment", _getEnv2(), getBuildTime());